import { JsonViewer } from "@/components/ui";
import { Label } from "@/components/ui/label";

export interface ExecutionResultsProps {
  isLoading: boolean;
  result?: unknown;
  error?: string | null;
}

export function ExecutionResults({
  isLoading,
  result,
  error,
}: ExecutionResultsProps) {
  // Don't render anything if there's nothing to show
  if (!isLoading && !result && !error) {
    return null;
  }

  return (
    <div className="border-t pt-6">
      <Label className="text-sm font-medium mb-3 block">Results</Label>

      {isLoading ? (
        <div className="min-h-32 border border-dashed rounded-lg flex items-center justify-center text-muted-foreground">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-muted-foreground/30 border-t-primary rounded-full animate-spin" />
            Executing...
          </div>
        </div>
      ) : error ? (
        <div className="border border-destructive rounded-lg p-4">
          <div className="text-sm font-medium text-destructive mb-2">
            Execution Error
          </div>
          <div className="text-sm text-destructive/80 font-mono whitespace-pre-wrap">
            {error}
          </div>
        </div>
      ) : result ? (
        <div className="border rounded-lg p-4">
          <div className="text-sm font-medium text-success mb-3">
            Execution Successful
          </div>
          <JsonViewer data={result} defaultExpanded />
        </div>
      ) : null}
    </div>
  );
}
